import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Logout from './views/Logout.vue'
import Layout from './views/Layout.vue'
import Dashboard from './views/Dashboard.vue'
import UserManagement from './views/UserManagement.vue'
import UserManagementAdd from './views/UserManagementAdd.vue'
import WebsiteManagement from './views/WebsiteManagement.vue'
import BranchMaintenance from './views/BranchMaintenance.vue'
import MechanicManagement from './views/MechanicManagement.vue'
import MechanicAdd from './views/MechanicAdd.vue'
import ServiceManagement from './views/ServiceManagement.vue'
import BranchEvent from './views/BranchEvent.vue'
import Settings from './views/Settings.vue'
import ServiceMenu from './views/ServiceMenu.vue'
import ServiceApproval from './views/ServiceApproval.vue'
import BranchEventAdd from './views/BranchEventAdd.vue'
import Reports from './views/Reports.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'adminhead',
            redirect: '/dashboard',
            component: Layout,
            children: [
                {
                    path: '/dashboard',
                    name: 'dashboard',
                    component: Dashboard,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/service-management',
                    name: 'service-management',
                    component: ServiceManagement,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/service-menu',
                    name: 'service-menu',
                    component: ServiceMenu,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/branch-event',
                    name: 'branch-event',
                    component: BranchEvent,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/branch-event-add',
                    name: 'branch-event-add',
                    component: BranchEventAdd,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/users-management',
                    name: 'users-management',
                    component: UserManagement,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/users-management/new',
                    name: 'users-management-add',
                    component: UserManagementAdd,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/website-management/',
                    name: 'website-management',
                    component: WebsiteManagement,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/branch-maintenance/',
                    name: 'branch-maintenance',
                    component: BranchMaintenance,
                    meta : {
                        public: false,
                    }
                },

                {
                    path: '/branch-mechanic-management/',
                    name: 'branch-mechanic-management',
                    component: MechanicManagement,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/branch-mechanic-new/',
                    name: 'branch-mechanic-new',
                    component: MechanicAdd,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/service-approval/',
                    name: 'service-approval',
                    component: ServiceApproval,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/reports/',
                    name: 'reports',
                    component: Reports,
                    meta : {
                        public: false,
                    }
                },
                {
                    path: '/settings/',
                    name: 'settings',
                    component: Settings,
                    meta : {
                        public: false,
                    }
                },
            ]
        },
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta : {
                public: true,
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta : {
                public: true,
            }
        },
    ]
})

